const KEYBOARD_KEY = Object.freeze({
  backspace: 'Backspace',
  delete: 'Delete',
});

export default KEYBOARD_KEY;
